import api from '../config/api'

export const moveApi = {
  login (email, password) {
    return api.post('/api/auth/move/login', { email, password })
  },

  me () {
    return api.get('/api/v1/move/me')
  },

  getNotificationPreferences () {
    return api.get('/api/v1/move/me/notification-preferences')
  },

  updateNotificationPreferences (payload) {
    return api.patch('/api/v1/move/me/notification-preferences', payload)
  },

  logout () {
    return api.post('/api/auth/logout')
  },

  requestPasswordReset (email) {
    return api.post('/api/auth/password/email', { email })
  },

  resetPassword (payload) {
    return api.post('/api/auth/password/reset', payload)
  },

  updateProfile (payload) {
    return api.put('/api/auth/user/profile', payload)
  },

  updateAvatar (file) {
    const formData = new FormData()
    formData.append('avatar', file)
    return api.post('/api/auth/user/avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  changePassword (payload) {
    return api.put('/api/auth/user/password', payload)
  },

  // Dashboard
  dashboardStats () {
    return api.get('/api/v1/move/dashboard/stats')
  },

  myTasks (params = {}) {
    const query = {}
    if (params.includeArchived) query.include_archived = 1
    return api.get('/api/v1/move/my-tasks', { params: query })
  },

  // Boards
  listBoards () {
    return api.get('/api/v1/move/boards')
  },

  createBoard (name) {
    return api.post('/api/v1/move/boards', { name })
  },

  getBoard (boardId) {
    return api.get(`/api/v1/move/boards/${boardId}`)
  },

  updateBoard (boardId, payload) {
    return api.put(`/api/v1/move/boards/${boardId}`, payload)
  },

  deleteBoard (boardId) {
    return api.delete(`/api/v1/move/boards/${boardId}`)
  },

  createList (boardId, name) {
    return api.post(`/api/v1/move/boards/${boardId}/lists`, { name })
  },

  updateList (boardId, listId, payload) {
    return api.put(`/api/v1/move/boards/${boardId}/lists/${listId}`, payload)
  },

  deleteList (boardId, listId) {
    return api.delete(`/api/v1/move/boards/${boardId}/lists/${listId}`)
  },

  reorderLists (boardId, lists) {
    return api.put(`/api/v1/move/boards/${boardId}/lists/reorder`, { lists })
  },

  createTask (boardId, payload) {
    return api.post(`/api/v1/move/boards/${boardId}/tasks`, payload)
  },

  updateTask (boardId, taskId, payload) {
    return api.put(`/api/v1/move/boards/${boardId}/tasks/${taskId}`, payload)
  },

  deleteTask (boardId, taskId) {
    return api.delete(`/api/v1/move/boards/${boardId}/tasks/${taskId}`)
  },

  addMember (boardId, userId, role = 'member') {
    return api.post(`/api/v1/move/boards/${boardId}/members`, { user_id: userId, role })
  },

  updateMember (boardId, userId, role) {
    return api.put(`/api/v1/move/boards/${boardId}/members/${userId}`, { role })
  },

  removeMember (boardId, userId) {
    return api.delete(`/api/v1/move/boards/${boardId}/members/${userId}`)
  },

  listComments (taskId) {
    return api.get(`/api/v1/move/tasks/${taskId}/comments`)
  },

  createComment (taskId, content) {
    return api.post(`/api/v1/move/tasks/${taskId}/comments`, { content })
  },

  deleteComment (commentId) {
    return api.delete(`/api/v1/move/comments/${commentId}`)
  },

  listLinks (taskId) {
    return api.get(`/api/v1/move/tasks/${taskId}/links`)
  },

  createLink (taskId, payload) {
    return api.post(`/api/v1/move/tasks/${taskId}/links`, payload)
  },

  deleteLink (linkId) {
    return api.delete(`/api/v1/move/links/${linkId}`)
  },

  // Admin users
  listUsers () {
    return api.get('/api/v1/move/admin/users')
  },

  inviteUser (payload) {
    return api.post('/api/v1/move/admin/users', payload)
  },

  resendInvite (moveUserId) {
    return api.post(`/api/v1/move/admin/users/${moveUserId}/resend-invite`)
  },

  updateUser (moveUserId, payload) {
    return api.put(`/api/v1/move/admin/users/${moveUserId}`, payload)
  },

  deleteUser (moveUserId) {
    return api.delete(`/api/v1/move/admin/users/${moveUserId}`)
  }
}

export default moveApi
